import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { PlaceholderCard } from './simple-result-card';
var defaultCount = 1;
/**
 * This component returns the set of Placeholder Cards with a total amount of placeholders based on the cardsCount input
 * Styling is dependent on the viewport.
 * Default return is a single card.
 * Note that React.Children.toArray is simply to add the React "key" to each element.
 * @param cardsCount
 * @param className
 * @return Returns an array of JSX Elements
 */
export var PlaceholderCards = function (_a) {
  var _b = _a.cardsCount,
    cardsCount = _b === void 0 ? defaultCount : _b,
    className = _a.className;
  var placeholderCards = [];
  for (var index = 0; index < cardsCount; index++) {
    placeholderCards.push(React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(PlaceholderCard, {
      key: index,
      index: index,
      className: className
    })), React.createElement(ViewMedium, null, React.createElement(PlaceholderCard, {
      key: index,
      index: index,
      className: classNames('placeholder-card', className)
    }))));
  }
  return React.createElement(React.Fragment, null, React.Children.toArray(placeholderCards));
};